import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, MessageCircle } from 'lucide-react';
import { GlowButton, SectionShell, GlassCard } from './LandingPrimitives';

const HeroSection = ({ onGetStarted, onTalkToUs }) => {
  return (
    <SectionShell id="top" className="pt-24 md:pt-28">
      <div className="grid items-center gap-10 lg:grid-cols-2">
        <div className="flex flex-col gap-6">
          <div>
            <h1 className="text-4xl font-extrabold italic leading-tight tracking-tight md:text-5xl lg:text-6xl">
              <span className="text-ga-text-primary">Ground</span>
              <span className="text-ga-primary">aale</span>
            </h1>
            <p className="mt-4 text-lg font-semibold text-ga-primary md:text-xl">Live for ground owners</p>
            <p className="mt-4 text-sm text-ga-text-muted md:text-base">
              Built with ground owners. Designed to eliminate booking chaos, staff confusion, and revenue leaks.
            </p>
          </div>
          <div className="flex flex-wrap gap-3">
            <GlowButton as={Link} to="/login" onClick={onGetStarted}>
              Get started <ArrowRight className="ml-2 h-4 w-4" />
            </GlowButton>
            <GlowButton as={Link} to="/contact" variant="ghost" onClick={onTalkToUs}>
              <MessageCircle className="mr-2 h-4 w-4" />
              Talk to us
            </GlowButton>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.08 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        >
          <GlassCard className="relative overflow-hidden p-0">
            <div className="absolute -right-20 -top-20 h-40 w-40 rounded-full bg-ga-green/20 blur-3xl" />
            <div className="absolute -bottom-16 -left-10 h-40 w-40 rounded-full bg-ga-lime/20 blur-3xl" />
            <p className="mb-3 px-5 pt-5 text-xs uppercase tracking-[0.2em] text-ga-text-subtle">Live Dashboard Preview</p>
            <img
              src={`${process.env.PUBLIC_URL}/images/preview-dashboard.png`}
              alt="GroundAale facility management dashboard showing facilities, services and contact details"
              className="w-full rounded-b-xl"
              loading="lazy"
            />
          </GlassCard>
        </motion.div>
      </div>
    </SectionShell>
  );
};

export default HeroSection;
